/* Sethukrishna — Modern Heirloom template interactions (Stage B) */
(function () {
  /* Long collection descriptions: two lines + "Read more" */
  function initClamp(root) {
    (root || document).querySelectorAll('[data-sk-clamp]:not([data-sk-clamped])').forEach(function (box) {
      var inner = box.firstElementChild;
      if (!inner) return;
      box.setAttribute('data-sk-clamped', '');
      if (inner.scrollHeight <= inner.clientHeight + 2) { box.removeAttribute('data-sk-clamped'); box.setAttribute('data-sk-clamp-skip', ''); return; }
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'sk-more'; btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = box.getAttribute('data-sk-clamped') === 'open';
        box.setAttribute('data-sk-clamped', open ? '' : 'open');
        btn.textContent = open ? 'Read more' : 'Read less';
        btn.setAttribute('aria-expanded', String(!open));
      });
      box.appendChild(btn);
    });
  }

  /* Option values are stored as handles ("slub-orange"); show them as words. Display only —
     the radio values sent to the cart are untouched. */
  function pretty(v) {
    v = (v || '').trim();
    if (!/^[a-z][a-z0-9]*(-[a-z][a-z0-9]*)+$/.test(v)) return v; /* word handles only: never sizes like 06-12 */
    return v.split('-').map(function (w, i) { return i && /^(and|with|of)$/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  function prettifyValue(el) {
    var p = pretty(el.textContent);
    if (p !== el.textContent.trim()) el.textContent = p;
  }
  function initOptions(root) {
    (root || document).querySelectorAll('.swatches__option-value:not([data-sk-pretty])').forEach(function (el) {
      el.setAttribute('data-sk-pretty', '');
      prettifyValue(el);
      new MutationObserver(function () { prettifyValue(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
    /* Colour swatches are empty labels: give each an accessible name + tooltip */
    (root || document).querySelectorAll('.swatches__swatch--color:not([data-sk-named])').forEach(function (sw) {
      var input = sw.querySelector('input'), label = sw.querySelector('label');
      if (!input || !label) return;
      sw.setAttribute('data-sk-named', '');
      var name = pretty(input.value) + (sw.classList.contains('soldout') ? ' (sold out)' : '');
      label.title = name;
      var span = document.createElement('span');
      span.className = 'visually-hidden-sk';
      span.textContent = name;
      label.appendChild(span);
    });
  }

  /* Cart lines (page + drawer) are injected by Drop's AJAX cart: prettify "Color: slub-orange" there too */
  function prettifyCartVariants(root) {
    (root || document).querySelectorAll('.ajax-cart__cart-variants:not([data-sk-pretty])').forEach(function (box) {
      box.setAttribute('data-sk-pretty', '');
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        node.nodeValue = node.nodeValue.replace(/(:\s*)([a-z][a-z0-9]*(?:-[a-z][a-z0-9]*)+)(?=\s|$)/g, function (m, sep, v) { return sep + pretty(v); });
      }
    });
  }
  var cartQueued = false;
  new MutationObserver(function () {
    if (cartQueued) return; cartQueued = true;
    requestAnimationFrame(function () { cartQueued = false; prettifyCartVariants(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* N-03: Shopify Inbox draws its bubble in a fixed layer at the top z-index, so near the bottom of the screen it
     sat on Add to cart / Buy it now (desktop at any width, phones). While the CLOSED bubble overlaps one of these
     controls, html.sk-chat-yield hides it (see sk-templates.css §20); it returns once the control scrolls away.
     An opened chat is never touched, and nothing changes in Inbox settings. */
  var CHAT_GUARD = [
    'form[action*="/cart/add"] [name="add"]', 'form[action*="/cart/add"] .shopify-payment-button',
    'form[action*="/cart/add"] .product__quantity', '[name="checkout"]', '.ajax-cart__buttons'
  ].join(',');
  function chatBubble(host) {
    var find = function (root) {
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        if (all[i].classList && all[i].classList.contains('activator-nudge')) return all[i];
        if (all[i].shadowRoot) { var f = find(all[i].shadowRoot); if (f) return f; }
      }
      return null;
    };
    return host.shadowRoot ? find(host.shadowRoot) : null;
  }
  var bubbleEl = null, guardQueued = false;
  function chatGuard() {
    guardQueued = false;
    var html = document.documentElement, host = document.querySelector('shopify-chat');
    if (!host || host.hasAttribute('open')) { html.classList.remove('sk-chat-yield'); return; }
    if (!bubbleEl || !bubbleEl.isConnected) bubbleEl = chatBubble(host);
    if (!bubbleEl) return;
    var b = bubbleEl.getBoundingClientRect(), pad = 8, hit = false;   /* layout box; unaffected by our visibility toggle */
    if (b.width) {
      var els = document.querySelectorAll(CHAT_GUARD);
      for (var i = 0; i < els.length && !hit; i++) {
        var el = els[i];
        if (el.closest('.cupertino-pane-wrapper')) continue;            /* the bubble is lifted above the sheet instead */
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height || getComputedStyle(el).visibility === 'hidden') continue;
        hit = r.left < b.right + pad && r.right > b.left - pad && r.top < b.bottom + pad && r.bottom > b.top - pad;
      }
    }
    html.classList.toggle('sk-chat-yield', hit);
  }
  function queueGuard() { if (!guardQueued) { guardQueued = true; requestAnimationFrame(chatGuard); } }
  window.addEventListener('scroll', queueGuard, { passive: true });
  window.addEventListener('resize', queueGuard);
  setInterval(queueGuard, 600);   /* drawers opening, variant changes, the bubble loading late */

  /* Cart remove (×) is an <li role="button" tabindex="0"> (cart-form.liquid): Enter/Space runs its existing click
     handler in cart.js, so keyboard users can remove an item the same way as a tap. Delegated, so it also covers
     cart markup re-rendered by the ajax cart. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('.js-cart-remove[role="button"]');
    if (!el) return;
    e.preventDefault();
    el.click();
  });

  function init(root) { initClamp(root); initOptions(root); prettifyCartVariants(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
